export const resolveOptions = <T>(options?: T[]): T[] => {
  return options ?? []
}
